export const KEY_GET_AUTH_SETTINGS = 'get.login.call';
export const KEY_POST_REFRESH_TOKEN = 'post.refresh-token.call';
